import React from 'react';
import { T } from '../customer/customers.theme';
import { EditIcon, TrashIcon } from '../customer/CustomersUI';
import { BoxIcon } from '../stock/StockIcons';

/**
 * The stations, the same row the printers use.
 *
 * Shorter, because a station is only a name: it carries no address and no
 * printer on purpose. A retired one stays in the list, greyed and badged, so a
 * manager can see that last quarter's "Kitchen" still exists behind the
 * reports even though nothing can be posted to it any more.
 */

const COPY = {
  retired: 'RETIRED',
  note: 'Stock issued with the Usage reason is posted to one of these.',
};

function RowAction({ label, tone, onClick, children }) {
  const [hovered, setHovered] = React.useState(false);
  const danger = tone === 'danger';

  return (
    <button
      type="button"
      title={label}
      aria-label={label}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 30,
        height: 30,
        background: hovered ? (danger ? T.dangerTint : T.hover) : 'transparent',
        border: 'none',
        borderRadius: T.radiusControl,
        color: hovered ? (danger ? T.danger : T.ink) : T.inkGhost,
        cursor: 'pointer',
      }}
    >
      {children}
    </button>
  );
}

export default function StationList({ stations, onEdit, onDelete }) {
  if (!stations.length) {
    return (
      <div style={{ padding: '10px 2px', fontSize: 12.5, color: T.inkFaint, lineHeight: 1.6 }}>
        No stations yet. {COPY.note}
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {stations.map((station) => {
        const active = station.isActive !== false;

        return (
          <div
            key={station._id}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 14,
              padding: '13px 18px',
              background: T.surface,
              border: `1px solid ${T.border}`,
              borderRadius: T.radiusPanel,
            }}
          >
            <span
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 34,
                height: 34,
                background: active ? T.selectedBg : T.shade,
                borderRadius: T.radiusControl,
                color: active ? T.brand : T.inkGhost,
                flexShrink: 0,
              }}
            >
              <BoxIcon size={17} />
            </span>

            <div style={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
              <span
                title={station.name}
                style={{
                  fontSize: 14,
                  fontWeight: 600,
                  color: active ? T.ink : T.inkFaint,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {station.name}
              </span>

              {active ? null : (
                <span
                  style={{
                    flexShrink: 0,
                    padding: '2px 8px',
                    background: T.shade,
                    border: `1px solid ${T.border}`,
                    borderRadius: T.radiusPill,
                    fontSize: 10,
                    fontWeight: 700,
                    color: T.inkFaint,
                    letterSpacing: 0.4,
                  }}
                >
                  {COPY.retired}
                </span>
              )}
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <RowAction label="Edit" onClick={() => onEdit(station)}>
                <EditIcon size={15} />
              </RowAction>
              <RowAction label="Retire" tone="danger" onClick={() => onDelete(station)}>
                <TrashIcon size={15} />
              </RowAction>
            </div>
          </div>
        );
      })}
    </div>
  );
}
